import { render, staticRenderFns } from "./badgeModal.vue?vue&type=template&id=5d6d4af5&scoped=true&"
import script from "./badgeModal.vue?vue&type=script&lang=js&"
export * from "./badgeModal.vue?vue&type=script&lang=js&"
import style0 from "./badgeModal.vue?vue&type=style&index=0&id=5d6d4af5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6d4af5",
  null
  
)

export default component.exports